import { UploadAssetRequest, UploadAssetResponse } from 'src/common-services/types/asset-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class AssetClient extends BaseClient {
  upload(request: UploadAssetRequest): Promise<UploadAssetResponse> {
    return this.call<UploadAssetResponse>('/assets', 'POST', {
      data: request,
      formData: true,
    })
  }
}
